import { Col, Row } from 'antd';
import classNames from 'classnames';

import { graphQLToFormAddressBookEntry } from '../../app/data/addressBookConversions';
import { formatLocationMedium } from '../../common/utils/formatUtils';
import { FAIcon } from '../../components/adapters/fontAwesomeAdapters';
import { useFormContext } from '../../components/forms/forms';
import { TemplateListDeleteButton } from '../../components/popups/templates/TemplatesFormDrawer';
import { BlockLink, LabelWithValue } from '../../components/typography';
import { useLayoutElementsStyles } from '../../components/layout/layoutElements.styles';
import { cssVariables } from '../../styles/cssVariables';
import { pxToNumber } from '../../utils/cssUtils';
import { useAddressBookStyles } from './addressBook.styles';

export function AddressBookListSection({ header, headerClassName }) {
  const { styles } = useAddressBookStyles();
  return (
    <div className={styles.section} data-letter={header}>
      <div className={classNames(styles.sectionHeader, headerClassName)}>
        {header}
      </div>
    </div>
  );
}

function StyledLabelWithValue({ className, ...rest }) {
  const { styles } = useAddressBookStyles();
  return (
    <LabelWithValue
      {...rest}
      size="xs"
      labelSize="full"
      nowrap
      className={classNames(styles.entryLabel, className)}
    />
  );
}

export function AddressBookListEntry({
  data,
  onEdit,
  onApply,
  active,
  index,
  onDelete: onDeleteOuter,
  removeDialogClassName,
  removeText,
  removeTextId,
  removeSuccessMessageId,
  readOnly,
  namePrefix,
}) {
  const { styles } = useAddressBookStyles();
  const { styles: layoutStyles } = useLayoutElementsStyles();
  const { formInstance, forceUpdate } = useFormContext();
  const setAndClose = () => {
    const fieldsValue = namePrefix
      ? {
          [namePrefix]: graphQLToFormAddressBookEntry(data),
        }
      : graphQLToFormAddressBookEntry(data);
    formInstance.setFieldsValue(fieldsValue);
    forceUpdate();
    onApply(data);
  };

  const onDelete = () => onDeleteOuter(data.id);

  const gutter = pxToNumber(cssVariables.spaceNorm);

  return (
    <BlockLink
      className={classNames(styles.entry, {
        active,
        'odd-index': index % 2 === 0,
        'even-index': index % 2 === 1,
      })}
      onClick={setAndClose}
      data-subject="address-book"
      data-role="item"
    >
      <Row align="stretch" gutter={gutter}>
        <Col className={layoutStyles.flex1}>
          <Row align="top" gutter={gutter}>
            <Col className="cols-1-2">
              <Row align="top" gutter={gutter}>
                <Col className="col-1">
                  <StyledLabelWithValue
                    labelId="addressBook.companyName"
                    text={data.companyName}
                  />
                  <StyledLabelWithValue
                    labelId="addressBook.keyword"
                    text={data.keyword}
                  />
                </Col>
                <Col className="col-2">
                  <StyledLabelWithValue
                    labelId="addressBook.address"
                    text={formatLocationMedium(data)}
                    showNewlines
                  />
                </Col>
              </Row>
            </Col>
            <Col className="col-3">
              <StyledLabelWithValue
                labelId="addressBook.phone"
                text={data.contact?.phone}
              />
              <StyledLabelWithValue
                labelId="addressBook.email"
                text={data.contact?.email}
              />
            </Col>
          </Row>
        </Col>
        {!readOnly && (
          <Col className={classNames('Clickable', styles.controlButtons)}>
            <FAIcon
              icon="edit"
              className="icon-14"
              onClick={e => {
                onEdit();
                e.stopPropagation();
              }}
            />
            <TemplateListDeleteButton
              onDelete={onDelete}
              removeDialogClassName={removeDialogClassName}
              removeText={removeText}
              removeTextId={removeTextId}
              removeSuccessMessageId={removeSuccessMessageId}
            >
              {({ open }) => (
                <FAIcon
                  icon="trash-alt"
                  className="icon-14"
                  onClick={e => {
                    open();
                    e.stopPropagation();
                  }}
                />
              )}
            </TemplateListDeleteButton>
          </Col>
        )}
      </Row>
    </BlockLink>
  );
}
